// material-ui
import { Typography } from "@mui/material";

// project imports
import { useSelector } from "react-redux";
import NavCollapse from "./NavCollapse";

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
  const menuItems = useSelector((state) => state?.menu?.menuItems);
  const navItems =
    menuItems?.length > 0
      ? menuItems?.map((item) => {
          switch (item.treeDepth) {
            case 1:
              return <NavCollapse key={item.id} menu={item} level={1} />;
            default:
              return (
                <Typography
                  key={item.id}
                  variant="h6"
                  color="error"
                  align="center"
                >
                  Menu Items Error
                </Typography>
              );
          }
        })
      : [];

  return <>{navItems}</>;
};

export default MenuList;
